/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.unitModule')
  .service('BulbUnitDroppableService', [
    'Restangular',
    'SerialSaveService',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    BulbUnitDroppableService,
  ]);

function BulbUnitDroppableService(Restangular, SerialSaveService) {
  let removeUnitIndex;
  let children;

  const childUnitRemove = function childUnitRemove(unit) {
    children.forEach((childUnit, index) => {
      if (childUnit === unit) {
        children.splice(index, 1);
        removeUnitIndex = index;
      }
    });
  };

  const childUnitRestore = function childUnitRestore(unit) {
    children.splice(removeUnitIndex, 0, unit);
  };

  this.onUnitDroppable = function onUnitDroppable(unitChildren, dropUnit, dropTargetUnit) {
    if (dropUnit.id !== dropTargetUnit.id) {
      children = unitChildren;
      childUnitRemove(dropUnit);
      SerialSaveService.save({
        save: () => Restangular.one('units', dropUnit.id)
          .customPOST({ parentUnitId: dropTargetUnit.id }, 'moveUnit')
      }).catch(() => {
        childUnitRestore(dropUnit);
      });
    }
  };
}
